import { UIFetchStatus, UIFlightData, UIClientFetchError } from "@flights/types";

export type State = {
  fetchStatus: UIFetchStatus;
  flight: UIFlightData | undefined;
  error?: UIClientFetchError;
};

export const getInitialState = (): State => ({
  fetchStatus: "initial",
  flight: undefined,
  error: undefined
});
